/* Start downloading an above-the-fold image early, at high priority, via
   <link rel="preload" as="image">. The later <img>/CSS background request
   for the same URL is served from that preload, so it is fetched once.

   - Each URL is preloaded at most once per page load.
   - `media` limits it to the viewports that actually show the image.
   - `imageSrcSet`/`imageSizes` match a responsive <img>, so the browser
     preloads the same candidate the <img> will pick. */
const preloaded = new Set();

export const preloadImage = (href, { media, imageSrcSet, imageSizes } = {}) => {
  const key = imageSrcSet || href;
  if (!key || preloaded.has(key) || typeof document === "undefined") return;
  if (media && window.matchMedia && !window.matchMedia(media).matches) return;
  preloaded.add(key);
  const link = document.createElement("link");
  link.rel = "preload";
  link.as = "image";
  if (href) link.href = href;
  if (imageSrcSet) link.setAttribute("imagesrcset", imageSrcSet);
  if (imageSizes) link.setAttribute("imagesizes", imageSizes);
  if (media) link.media = media;
  link.setAttribute("fetchpriority", "high");
  document.head.appendChild(link);
};

export default preloadImage;
